var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var MessageForm = require('./layout/messageForm.jsx');
var Callout = require('../../components/callout.jsx');

var MessageEdit = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        var token = this.props.auth.token;

        if(token){
            this.props.fetchTagsIfNeeded(token);
            this.props.fetchTargetsIfNeeded(token);
            this.props.fetchMessage(this.props.params.id, token);
        }
    },

    handleOnSubmit: function(formData){
        this.props.editMessage(this.props.params.id, formData, this.props.auth.token);
    },

    hasDataLoaded: function(){
        return this.props.message.messageData._id === this.props.params.id;
    },

    getContent: function(){
        var error = this.props.message.error;

        var children = [
            <div className="row" key={0}>
                <div className="small-12 medium-10 medium-offset-1 large-8 large-offset-2 column end">
                    {Object.keys(error).length !== 0 &&
                        <Callout type="alert" message={error} handleClose={this.props.clearMessageError} />
                    }
                    <MessageForm isEdit onSubmit={this.handleOnSubmit} {...this.props} />
                </div>
            </div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function () {
        return (
            <div className="content">
                <Helmet title='Edit Message' />
                {this.getContent()}
            </div>
        );
    }
});

module.exports = MessageEdit;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/message-edit.jsx